import { BusinessUnitDto, JobOverview } from 'core/models/job';
import { ActiveFilters } from './types';

export const prepareList = (
  schedules: JobOverview[],
  searchText: string,
  filters: ActiveFilters
): JobOverview[] => {
  const storesFilter = storeFilterFactory(filters.stores);
  const queryFilter = singleValueFilterFactory(
    filters.queries,
    j => j.queryName
  );
  const authorFilter = singleValueFilterFactory(
    filters.authors,
    j => j.authorName
  );
  const statusFilter = singleValueFilterFactory(filters.status, j => j.status);
  const repetitionTypeFilter = singleValueFilterFactory(
    [...filters.repetitionType],
    j => j.repetition?.type.toLowerCase()
  );

  const prefilteredSchedules = filterBySearchText(searchText, schedules);

  return filterBy(
    filterBy(
      filterBy(
        filterBy(
          filterBy(prefilteredSchedules, filters.authors, authorFilter),
          filters.status,
          statusFilter
        ),
        filters.stores,
        storesFilter
      ),
      filters.queries,
      queryFilter
    ),
    filters.repetitionType,
    repetitionTypeFilter
  );
};

export const storeFilterFactory =
  (selectedStores: string[]) => (j: JobOverview) =>
    j.stores.some((jobStore: BusinessUnitDto) =>
      selectedStores.includes(jobStore.id)
    );

export const singleValueFilterFactory =
  (selectedValues: string[], pickerF: (j: JobOverview) => string) =>
  (j: JobOverview) =>
    selectedValues.includes(pickerF(j));

export const filterBy = (
  schedules: JobOverview[],
  values: string[],
  filterF: (j: JobOverview) => boolean
): JobOverview[] => {
  if (values.length === 0) {
    return schedules;
  }

  return schedules.filter(filterF);
};

export const filterBySearchText = (search: string, jobs: JobOverview[]) => {
  const sanitizedSearch = search.trim().toLocaleLowerCase();
  if (sanitizedSearch === '') {
    return jobs;
  }
  return jobs.filter(j => {
    return (
      j.title.toLocaleLowerCase().includes(sanitizedSearch) ||
      j.queryName.toLocaleLowerCase().includes(sanitizedSearch) ||
      j.authorName.toLocaleLowerCase().includes(sanitizedSearch)
    );
  });
};
